import React from 'react';
import $ from 'jquery';
import { Component }  from 'ml-component-web';

export default class Modal extends Component {

	componentDidMount() {
		super.componentDidMount && super.componentDidMount();
		$('#'+this.getId()).find('input[type=text],input[type=email],textarea,select').filter(':visible:first').focus();
	}

	getId() {
		return this.props.name + 'Modal';
	}

	render() {
		var title;
		if (this.props.title) {
			title = this.translate(this.props.title);
		}
		var icon;
		if (this.props.icon) {
			icon = (
				<i className="material-icons">{this.props.icon}</i>
			)
		}

		var header;
		if (title || icon) {
			header = (
				<div className="my-modal-header">
        			{icon}
        			<h5 className="my-modal-title">{title}</h5>
        		</div>
			)
		}
		var className = 'my-modal ';
		if (this.props.className) {
			className += this.props.className;
		}
    	
        return ( 
        	<div className={className} id={this.getId()} tabIndex="-1" role="dialog">
        		{header}
                <div className="my-modal-content">
	        		{this.props.children}
			    </div>
		    </div>
        )
	}
}


/** WEBPACK FOOTER **
 ** ./src/shared/modal/Modal.js
 **/